<template>
  <div>
    <div class="main-title">教练登记</div>
    <div class="main-content">
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-button type="primary" @click="add()">添加教练</el-button>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="searchForm.school_id"
              filterable
              style="width:194px;"
              @change="search(searchForm)"
              placeholder="搜索驾校">
              <el-option label="全部驾校" :value="null"></el-option>
              <el-option
                v-for="item in schoolList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索姓名拼音/身份证/手机号"
              v-model="searchForm.query"
              prefix-icon="el-icon-search"
              clearable
              style="width:250px;"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="searchForm.area" placeholder="所属区域" style="width:140px;" @change="search(searchForm)">
              <el-option label="所属区域" :value="null"></el-option>
              <el-option label="武昌" value="武昌"></el-option>
              <el-option label="汉口" value="汉口"></el-option>
              <el-option label="汉阳" value="汉阳"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-button-group>
          <el-button icon="el-icon-download" size="small" @click="excel" :loading="exporting"></el-button>
          <el-button icon="el-icon-printer" size="small" @click="print"></el-button>
          <el-button icon="el-icon-refresh" size="small" @click="refresh" :loading="loading"></el-button>
        </el-button-group>
      </div>
      <el-table
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%">
        <el-table-column
          prop="school_name"
          label="所属驾校"
          width="150">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          width="100">
        </el-table-column>
        <el-table-column
          prop="sex"
          label="性别"
          width="60">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="120">
        </el-table-column>
        <el-table-column
          prop="idcard"
          label="身份证号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="area"
          label="所属区域"
          width="80">
        </el-table-column>
        <el-table-column
          label="状态"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.is_del === '0'">正常</span>
            <span style="color:red;" v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column
          label="照片"
          width="70">
          <template slot-scope="scope">
            <img
              v-if="scope.row.face_photo_url"
              :src="scope.row.face_photo_url"
              style="width:40px;height:40px;object-fit:cover;border-radius:4px;cursor:pointer;"
              @click="openCamera(scope.row)" />
            <span v-else style="color:#ccc;font-size:12px;">未拍</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">修改</el-button>
            <el-button type="text" @click="openCamera(scope.row)">拍照授权</el-button>
            <el-button type="text" @click="del(scope.row)" v-if="scope.row.is_del === '0'" style="color:red;">禁用</el-button>
            <el-button type="text" @click="del(scope.row)" v-else>启用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="currentPage"
        :page-sizes="[minPageSize, 50, 100, 500]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加/修改教练 -->
    <el-dialog :title="form.id > 0 ? '修改教练信息' : '添加教练'" :visible.sync="formVisible">
      <el-form :model="form" ref="form" :rules="formRules" label-width="200px">
        <el-form-item prop="name" label="教练姓名">
          <el-input v-model="form.name" style="width:194px;" :disabled="form.id > 0"></el-input>
        </el-form-item>
        <el-form-item prop="sex" label="性别">
          <el-select v-model="form.sex" style="width:194px;">
            <el-option label="男" value="男"></el-option>
            <el-option label="女" value="女"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phone" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item label="身份证号">
          <el-input v-model="form.idcard" style="width:194px;"></el-input>
        </el-form-item>
        <el-form-item prop="school_id" label="所属驾校">
          <el-select
            v-model="form.school_id"
            placeholder="请选择驾校"
            filterable
            style="width:194px;">
            <el-option
              v-for="item in schoolList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="area" label="所属区域">
          <el-select
            v-model="form.area"
            placeholder="请选择所属区域"
            style="width:194px;">
            <el-option label="" value=""></el-option>
            <el-option label="武昌" value="武昌"></el-option>
            <el-option label="汉口" value="汉口"></el-option>
            <el-option label="汉阳" value="汉阳"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="commit" :loading="commiting">确 定</el-button>
        <el-button @click="formVisible = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 拍照 -->
    <el-dialog
      title="教练拍照"
      :visible.sync="cameraDialogVisible"
      width="540px"
      :close-on-click-modal="false"
      @close="closeCamera">
      <div style="text-align:center;">
        <p style="margin:0 0 10px;color:#666;">
          教练：<strong>{{ currentCoach ? currentCoach.name : '' }}</strong>
          &nbsp;&nbsp;身份证：{{ currentCoach ? currentCoach.idcard : '' }}
        </p>
        <div v-show="!capturedPhoto">
          <video
            ref="video"
            autoplay
            playsinline
            style="width:480px;height:360px;background:#222;border-radius:4px;display:block;margin:0 auto;">
          </video>
        </div>
        <div v-if="capturedPhoto" style="position:relative;display:inline-block;">
          <img
            :src="capturedPhoto"
            style="width:480px;height:360px;object-fit:contain;border-radius:4px;border:1px solid #ddd;display:block;" />
          <div v-if="authorizing" style="position:absolute;inset:0;background:rgba(0,0,0,0.45);border-radius:4px;display:flex;align-items:center;justify-content:center;">
            <span style="color:#fff;font-size:16px;"><i class="el-icon-loading"></i> 正在保存...</span>
          </div>
          <div v-if="authError" style="margin-top:8px;color:#f56c6c;font-size:13px;">{{ authError }}</div>
        </div>
        <canvas ref="canvas" style="display:none;" width="480" height="360"></canvas>
      </div>
      <div slot="footer" style="text-align:center;">
        <template v-if="!capturedPhoto">
          <el-button type="primary" icon="el-icon-camera" @click="capturePhoto" :disabled="!cameraReady">拍 照</el-button>
        </template>
        <template v-else-if="authError">
          <el-button icon="el-icon-refresh" @click="retakePhoto">重 拍</el-button>
        </template>
        <el-button @click="closeCamera" :disabled="authorizing" style="margin-left:10px;">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '../../mixins/ListFunc'
import DatePickerOptions from '../../mixins/DatePickerOptions'
export default {
  mixins: [ListFunc, DatePickerOptions],
  data () {
    return {
      sqlcode: 'coach_list',
      searchForm: {
        query: '',
        school_id: null,
        area: null
      },
      form: {
        id: 0,
        name: '',
        sex: '男',
        phone: '',
        idcard: '',
        school_id: null,
        discount_rate: 0,
        fxl: 0,
        fxl3: 0,
        area: ''
      },
      formRules: {
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' }
        ],
        school_id: [
          { required: true, message: '请选择所属驾校', trigger: 'blur' }
        ]
      },
      formVisible: false,
      commiting: false,
      schoolList: [],
      cameraDialogVisible: false,
      currentCoach: null,
      capturedPhoto: null,
      cameraReady: false,
      authorizing: false,
      authError: '',
      videoStream: null
    }
  },
  mounted () {
    this.fetchSchoolList()
  },
  methods: {
    fetchSchoolList () {
      this.$http.get('/dbapi/school_combo').then(response => {
        if (response.data.success) {
          this.schoolList = response.data.list
        }
      })
    },
    add () {
      this.form = {
        id: 0,
        name: '',
        sex: '男',
        phone: '',
        idcard: '',
        school_id: null,
        discount_rate: 0,
        fxl: 0,
        fxl3: 0,
        area: ''
      }
      this.formVisible = true
    },
    edit (row) {
      this.form = {
        id: row.id,
        name: row.name,
        sex: row.sex,
        phone: row.phone,
        idcard: row.idcard,
        school_id: row.school_id,
        discount_rate: row.discount_rate,
        fxl: row.fxl,
        fxl3: row.fxl3,
        area: row.area
      }
      this.formVisible = true
    },
    commit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.commiting = true
          let url = '/dbapi/update_coach'
          if (this.form.id === 0) {
            url = '/dbapi/insert_coach'
          }
          this.form.name_pinyin = this.form.name_py = this.form.name
          this.$http.post(url, this.form).then(response => {
            this.commiting = false
            if (response.data.success) {
              this.formVisible = false
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        }
      })
    },
    del (row) {
      this.$confirm(row.is_del === '1' ? '确定要启用吗？' : '确定要禁用吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.post('/dbapi/del_coach', {
          id: row.id,
          is_del: row.is_del === '1' ? '0' : '1'
        }).then(response => {
          if (response.data.success) {
            if (row.is_del === '0') {
              this.$http.post('/gate/coach/disable', {
                coach_id: row.id
              }).then(res => {
                if (res.data.deleted > 0) {
                  this.$message.success('已禁用并删除闸机授权')
                } else {
                  this.$message.success('已禁用')
                }
              }).catch(() => {
                this.$message.success('已禁用（闸机授权删除失败）')
              })
            }
            this.refresh()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      })
    },
    openCamera (row) {
      if (!row.idcard) {
        return this.$message.error('该教练未录入身份证号，无法授权')
      }
      this.currentCoach = row
      this.capturedPhoto = null
      this.cameraReady = false
      this.cameraDialogVisible = true
      this.$nextTick(() => {
        this.startCamera()
      })
    },
    startCamera () {
      navigator.mediaDevices.getUserMedia({ video: { width: 480, height: 360, facingMode: 'user' } })
        .then(stream => {
          this.videoStream = stream
          this.$refs.video.srcObject = stream
          this.cameraReady = true
        })
        .catch(err => {
          this.$message.error('无法访问摄像头：' + err.message)
          this.cameraDialogVisible = false
        })
    },
    capturePhoto () {
      const canvas = this.$refs.canvas
      canvas.getContext('2d').drawImage(this.$refs.video, 0, 0, 480, 360)
      this.capturedPhoto = canvas.toDataURL('image/jpeg', 0.9)
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(t => t.stop())
        this.videoStream = null
      }
      this.submitAuth()
    },
    retakePhoto () {
      this.capturedPhoto = null
      this.authError = ''
      this.cameraReady = false
      this.$nextTick(() => {
        this.startCamera()
      })
    },
    closeCamera () {
      if (this.videoStream) {
        this.videoStream.getTracks().forEach(t => t.stop())
        this.videoStream = null
      }
      this.cameraDialogVisible = false
      this.capturedPhoto = null
      this.currentCoach = null
      this.cameraReady = false
      this.authError = ''
    },
    dataUrlToBlob (dataUrl) {
      const arr = dataUrl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      const u8arr = new Uint8Array(bstr.length)
      for (let i = 0; i < bstr.length; i++) {
        u8arr[i] = bstr.charCodeAt(i)
      }
      return new Blob([u8arr], { type: mime })
    },
    submitAuth () {
      if (!this.capturedPhoto || !this.currentCoach) return
      this.authorizing = true
      this.authError = ''
      const blob = this.dataUrlToBlob(this.capturedPhoto)
      const formData = new FormData()
      formData.append('file', blob, `coach_${this.currentCoach.id}_${Date.now()}.jpg`)
      this.$http.post('/api/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(uploadRes => {
          if (!uploadRes.data.success) {
            throw new Error('照片上传失败：' + uploadRes.data.message)
          }
          return this.$http.post('/gate/coach/auth', {
            coach_id: this.currentCoach.id,
            photo_url: uploadRes.data.url
          })
        })
        .then(authRes => {
          this.$message.success('拍照成功')
          this.closeCamera()
          this.refresh()
        })
        .catch(err => {
          this.authError = err.message || '操作失败，请重拍'
        })
        .finally(() => {
          this.authorizing = false
        })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/access/CoachRegister.vue